import { render, staticRenderFns } from "./MyBookMatch.vue?vue&type=template&id=f7977aa8&scoped=true"
import script from "./MyBookMatch.vue?vue&type=script&lang=js"
export * from "./MyBookMatch.vue?vue&type=script&lang=js"
import style0 from "./MyBookMatch.vue?vue&type=style&index=0&id=f7977aa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7977aa8",
  null
  
)

export default component.exports